import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";

const HomeSectionHeader: FCX = ({
    children,
    className,
    style,
    testId,
}) => {
    return (
        <div
            className={cn('HomeSectionHeader', className)}
            style={style}
            data-testid={testId}
        >
            {children}
        </div>
    );
};

export default HomeSectionHeader;